import module from 'empresa/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

const diacriticosRegex = /[,.\u0300-\u036f]/g
const diacriticosEspacios = /\s+\s/g
const normalizar = (valor) => valor.normalize('NFD').replace(diacriticosRegex, '').replace(diacriticosEspacios, ' ').toUpperCase().trim()

export class EmpresaConfiguracionRegistrosPatronalesComponent {
  empresaId
  registroPatronalOrigenId
  registroPatronalDestinoId
  registrosPatronales = []
  registrosPatronalesDestino = []

  constructor (EmpresaConfiguracionRegistrosPatronales, EmpresaConfiguracionRegistrosPatronalesMigrarColaboradores, $state) {
    this.EmpresaConfiguracionRegistrosPatronales = EmpresaConfiguracionRegistrosPatronales
    this.EmpresaConfiguracionRegistrosPatronalesMigrarColaboradores = EmpresaConfiguracionRegistrosPatronalesMigrarColaboradores
    this.$state = $state
  }

  $onInit () {
    this.promise = this.EmpresaConfiguracionRegistrosPatronales.get(this.empresaId)
    .then(({data}) => {
      this.registrosPatronales = data.map(i => ({
        id: i.id,
        descripcion: i.registroPatronal,
        clase: i.clase,
      }))
    })
  }

  actualizar () {
    this.colaboradoresMigrar = this.colaboradores.filter(i => i.seleccionado)
  }

  cargarColaboradores () {
    this.noData = false
    this.registrosPatronalesDestino = this.registrosPatronales.filter(i => i.id !== this.registroPatronalOrigenId)
    this.registroPatronalDestinoId = null
    this.EmpresaConfiguracionRegistrosPatronalesMigrarColaboradores.get(this.empresaId, this.registroPatronalOrigenId)
    .then(({data}) => {
      let datos = orderBy(data, ['colaborador'])
      this.colaboradores = datos.map(i => ({
        colaborador: normalizar(i.colaborador),
        id: i.id,
        proyecto: i.proyecto,
        seleccionado: false,
      }))
    })
    .finally(() => {
      this.noData = this.colaboradores.length === 0
    })
  }

  finalizar (resultado) {
    if(resultado) {
      this.$state.go('empresa.configuracion.registrosPatronales');
    } else {
      this.migrando = false
    }

  }

  migrar () {
    this.data = {
      colaboradores: this.colaboradoresMigrar.map(i => (i.id)).join(','),
      origenId: this.registroPatronalOrigenId,
      destinoId: this.registroPatronalDestinoId,
      empresaId: this.empresaId
    }
    this.migrando = true
  }

  verificarRegistros() {
    let a = this.registrosPatronales.find(i => i.id === this.registroPatronalOrigenId)?.clase
    let b = this.registrosPatronales.find(i => i.id === this.registroPatronalDestinoId)?.clase

    console.log(a+ 'sda')
    console.log(b + 'dsad')

    this.mismaClase = a !== b
  }
}

module.component('empresaConfiguracionRegistrosPatronalesMigrar', {
  controller: EmpresaConfiguracionRegistrosPatronalesComponent,
  template,
  bindings: {
    empresaId: '<',
  },
})



// WEBPACK FOOTER //
// ./src/empresa/components/configuracion/registrosPatronales/migrar/component.js